import React from 'react';
import RestInputItem from '../../../../components/RestInput/RestInputItem';

const SalerBSForm = props => (
  <div {...props}>
    <RestInputItem source="name" header="salers.name" />
  </div>
);

SalerBSForm.propTypes = {};

export default SalerBSForm;
